/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from 'reactstrap';
import { addUser, cleanUsers } from '../../store/actions';
import { useSelector, useDispatch } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { useForm, Controller } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import { useTranslation } from 'react-i18next';

function FormModal() {
  const [modal, setModal] = useState(false);

  const addedUser = useSelector((state) => state.usersData.addedUser);
  const dispatch = useDispatch();

  const { handleSubmit, errors, reset, control } = useForm();
  const history = useHistory();
  const { addToast } = useToasts();
  const { t } = useTranslation();

  const toggleModal = () => {
    setModal(!modal);
  };

  const onSubmit = (data) => {
    dispatch(addUser(data));
  };

  useEffect(() => {
    dispatch(cleanUsers());
    if (addedUser && !addedUser.success) {
      addToast(t('common.somethingWrong'), {
        appearance: 'error',
        autoDismiss: true,
      });
    } else if (addedUser && addedUser.success) {
      addToast(t('common.dataaddedsuccessfully'), {
        appearance: 'success',
        autoDismiss: true,
      });
      history.push('/adminview');
      reset();
    }
  }, [addedUser]);

  return (
    <>
      <Button onClick={toggleModal} color="info" className="btn-labeled">
        <span className="btn-label">
          <i className="fas fa-plus" />
        </span>
        {t('users.add')}
      </Button>
      <Modal isOpen={modal} toggle={toggleModal} className="custom-modal">
        <ModalHeader toggle={toggleModal}>{t('users.add')}</ModalHeader>
        <form onSubmit={handleSubmit(onSubmit)}>
          <ModalBody>
            <div className="form-row align-items-center">
              <div className="col-12 col-md-12 col-xl-12">
                <label className="col-form-label" htmlFor="inlineFormInput">
                  {t('common.email')}
                </label>
                <Controller
                  name="email"
                  control={control}
                  rules={{
                    required: true,
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: t('common.doesNotMatchEmail'),
                    },
                  }}
                  defaultValue=""
                  render={({ onChange, value }) => (
                    <Input onChange={onChange} value={value} />
                  )}
                />
                {errors.email && errors.email.type === 'required' && (
                  <span className="custom-invalid-input">
                    This field is required
                  </span>
                )}
                {errors.email && errors.email.type === 'pattern' && (
                  <span className="custom-invalid-input">
                    {errors.email.message}
                  </span>
                )}
              </div>
              <div className="col-12 col-md-12 col-xl-12">
                <label className="col-form-label" htmlFor="inlineFormInput">
                  {t('users.password')}
                </label>
                <Controller
                  name="password"
                  control={control}
                  defaultValue=""
                  rules={{ required: true }}
                  render={({ onChange, value }) => (
                    <Input type="password" onChange={onChange} value={value} />
                  )}
                />
                {errors.password && errors.password.type === 'required' && (
                  <span className="custom-invalid-input">
                    This field is required
                  </span>
                )}
              </div>
              <div className="col-12 col-md-12 col-xl-12">
                <label className="col-form-label" htmlFor="inlineFormInput">
                  {t('common.name')}
                </label>
                <Controller
                  name="name"
                  control={control}
                  rules={{ required: true }}
                  defaultValue=""
                  render={({ onChange, value }) => (
                    <Input onChange={onChange} value={value} />
                  )}
                />
                {errors.name && errors.name.type === 'required' && (
                  <span className="custom-invalid-input">
                    This field is required
                  </span>
                )}
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit">
              {t('users.add')}
            </Button>
            <Button color="secondary" onClick={toggleModal}>
              {t('common.cancel')}
            </Button>
          </ModalFooter>
        </form>
      </Modal>
    </>
  );
}

export default FormModal;
